import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { useMemo } from "react";
import UspItem from "@/pages/homePageV2/homePageComponents/components/Usps/UspItem";
import useBoolean from "@hooks/useBoolean";
import UspsLearnMoreModal from "@/pages/homePageV2/homePageComponents/components/Usps/UspsLearnMoreModal";
import { trackEvents } from "@/common/events/events";
var UspsSection = function UspsSection() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var popup = useBoolean(false);
  var uspsItems = useMemo(function () {
    return [{
      key: "usps1",
      src: "/assets/images/usps/days.svg",
      title: tShort("whyToBuyUsp/usp_one_title", {
        ns: "web_home"
      })
    }, {
      key: "usps2",
      src: "/assets/images/usps/year.svg",
      title: tShort("whyToBuyUsp/usp_two_title", {
        ns: "web_home"
      })
    }, {
      key: "usps3",
      src: "/assets/images/usps/checked.svg",
      title: tShort("whyToBuyUsp/usp_three_title", {
        ns: "web_home"
      })
    }, {
      key: "usps4",
      src: "/assets/images/usps/new.svg",
      title: tShort("whyToBuyUsp/usp_four_title", {
        ns: "web_home"
      })
    }];
  }, [tShort]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: "w-full lg:max-w-[958px] lg:mx-auto"
  }, /*#__PURE__*/React.createElement("section", {
    className: "pt-8 px-4 pb-6 bg-blue-alice relative overflow-hidden mt-6 lg:rounded-2xl lg:px-9 lg:pt-10 lg:pb-8 lg:mt-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-6 text-center lg:max-w-[50%] lg:mx-auto lg:mb-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-4 mb-8 lg:mt-4 justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-64 h-px bg-gradient-to-r from-transparent  to-primary max-w-16 transform rotate-180 en:rotate-0"
  }), /*#__PURE__*/React.createElement("h2", {
    className: "text-primary text-xl font-bold lg:text-2xl"
  }, tShort("whyToBuyUsp/main_title", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-64 h-px bg-gradient-to-l from-primary  to-transparent max-w-16 en:rotate-180"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-[repeat(auto-fill,minmax(70px,1fr))] gap-[0.15rem] [@media(min-width:361px)]:grid-cols-[repeat(auto-fill,minmax(80px,1fr))] [@media(min-width:361px)]:gap-1 [@media(min-width:361px)]:lg:gap-4 [@media(min-width:361px)]:lg:grid-cols-[repeat(auto-fill,minmax(200px,1fr))]"
  }, uspsItems.map(function (item) {
    return /*#__PURE__*/React.createElement(UspItem, {
      key: item.key,
      src: item.src,
      title: item.title
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-6 text-center text-primary text-sm font-medium underline cursor-pointer hover:text-primary-120 transition-colors duration-200 ease-in",
    onClick: function onClick() {
      popup.setTrue();
      trackEvents("usp_cta_clicked", {
        referral_location: "homepage",
        usp_number: 0
      });
    }
  }, tShort("whyToBuyUsp/usp_cta", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement(UspsLearnMoreModal, {
    open: popup.value,
    onClose: function onClose() {
      return popup.setFalse();
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-[256px] h-[256px] rounded-full border-[60px] border-solid border-[#E6ECFA] absolute bottom-[-74px] left-[-132px] lg:w-[377px] lg:h-[377px] lg:left-[-205px] lg:bottom-[-160px] lg:border-[80px]"
  }), /*#__PURE__*/React.createElement("div", {
    className: "hidden w-[377px] h-[377px] rounded-full border-[80px] border-solid border-[#E6ECFA] absolute top-[-127px] right-[-203px] lg:block"
  }))));
};
export default UspsSection;